module.exports = __webpack_public_path__ + "static/media/point_info.89416944.png";